import React, { Component } from "react";
import Section from "./Section";

class SafeguardingPage extends Component {
    render() {
        return (
            <Section title={'Responsabile Safeguarding'}>
                <div>
                    <section className="section page-content cm-services">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-8">
                                    <img className="img-fluid" src={process.env.PUBLIC_URL + '/assets/images/responsabile_safeguarding.jpg'} alt="" />
                                    <h1 className="text-dark mt-10 mb-25">Nomina ufficiale</h1>
                                    <p className="mt-15 text-dark">Il nostro tecnico Paolo Ranieri è stato nominato Responsabile contro abusi, violenze e discriminazioni.</p>
                                    <p className="mt-15 text-dark">È un ruolo di rilievo che è stato finalmente definito nel quadro della riforma dello sport, per promuovere il rispetto reciproco per tutti coloro che sono parte attiva della società: atleti, parenti e tecnici.
                                    </p>
                                    <p className="mt-15 text-dark">Siamo contenti di questa nomina e siamo certi che Paolo saprà ricoprirlo degnamente
                                    </p>
                                    <p className="mt-15 text-dark">Con la nomina sono stati emessi il Modello Organizzativo della Società e il Codice di Condotta, entrambi sono scaricabili dal nostro sito internet.
                                    </p>
                                    <p className="mt-15 text-dark">E' possibile scaricare i rispettivi moduli ai seguenti link:
                                        <a href={process.env.PUBLIC_URL + '/assets/images/FBS-0001_Codice_di_Condotta_Fiorentina_Baseball_R00.pdf'} download>Condice di Condotta Fiorentina Baseball</a><br />
                                        <a href={process.env.PUBLIC_URL + '/assets/images/FBS-0002_Modello_Organizzativo_Fiorentina_Baseball_R00.pdf'} download>Modello organizzativo Fiorentina Baseball</a><br />
                                    </p>
                                    <img className="img-fluid" src={process.env.PUBLIC_URL + '/assets/images/nomina_responsabile_safeguarding.jpg'} alt="" />
                                </div>
                            </div>
                        </div>
                    </section>
                </div >
            </Section >
        );
    }
}

export default SafeguardingPage;